import { createFileRoute } from "@tanstack/react-router";
import { ensureRouteTranslationModuleLoaded } from "@/services/culture/routeTranslationPreload";

export const Route = createFileRoute("/uns")({
  beforeLoad: async () => {
    await ensureRouteTranslationModuleLoaded("uns");
  },
  staticData: {
    title: "titles.uns",
  },
});
